// TODO: Refactor this component.
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./style.scss";
import PopUpOutline from "../PopUpOutline";
import { isItemTypeEpisode } from "../../shared/utils/content";
import constants from "../../shared/constants";
import recordingConstants from "../../shared/constants/recordingConstants";
import {
  deleteRecording,
  stopCPVRRecording,
  isCPVRRecordingInProgress,
  buildAndFindEventContentIdIndex,
  isSportsEvent,
  isSportSeriesRecording,
  getAllEventsOfSeries,
} from "../../shared/utils/recordingHelper";
import { editRecordingAction, deleteRecordingAction } from "../../pages/RecordingsPage/state/actions";
import { useReducers } from "../../shared/hooks/useReducer";
import { trackGenericAction } from "../../shared/analytics/dataLayer";
import { ANALYTICS_EVENT_TYPES, MAPPED_CONTENT_TYPES } from "../../shared/constants/analytics";
import { mapRecordingSeriesMediaContent } from "../../shared/analytics/helpers";
import { getCustomContextMetadata, trackConvivaCustomEvent } from "../../shared/analytics/media";
import { getAutoGeneratedObject, getAutogeneratedEpisodeString } from "../../shared/utils";

import { logDTEvent } from "../../shared/analytics/dynatrace";
import { DT_EVENTS } from "../../shared/constants/dynatrace";

const { PAGE_CONTENT_ITEM_TYPES, REDUCER_TYPE, CONTENT_ITEM_TYPES } = constants;
const { RECORDING_PARAMS } = recordingConstants;

const CancelPopup = ({
  deleteRecordingAction,
  editRecordingAction,
  recordingInfo,
  programDetails,
  isMR,
  closeModal,
  isRecordingRecorded,
  recordingType,
  closeRecordingSettings,
  isProgramOfSeries,
  recordGUID,
  isRecordingNow,
  isInHome,
  userProfile,
}) => {
  const { t: translate } = useTranslation();
  const { provider: appProvider, featureToggles } = useReducers(REDUCER_TYPE.APP);
  const [recordingInfoDetails, setRecordingInfoDetails] = useState();
  const [headingText, setHeadingText] = useState("");
  const [messageText, setMessageText] = useState("");
  const [cancelCTAText, setCancelCTAText] = useState("");
  const [primaryCTAActionType, setPrimaryCTAActionType] = useState("");

  const defaultKeepCTAText = translate(RECORDING_PARAMS.KEEP_RECORDING);
  const [keepCTAText, setKeepCTAText] = useState(defaultKeepCTAText);
  const { isConvivaAppTrackerEnabled, isDynatraceTrackingEnabled } = featureToggles;

  const isSingleEvent =
    recordingType === RECORDING_PARAMS.EVENT && !recordingInfo?.eventRecordingItem?.metadata?.recordingSeriesId; // not part of series recording

  const isTeamRecording = useMemo(() => {
    if (recordingType?.toLowerCase() === CONTENT_ITEM_TYPES.team) {
      return true;
    }
    return recordingInfo?.eventRecordingItem?.metadata?.isTeamRecording === true;
  }, [recordingInfo, recordingType]);

  const isSportRecording = useMemo(() => {
    if (recordingType === RECORDING_PARAMS.SERIES) {
      return isSportSeriesRecording(recordingInfo?.seriesRecordingItem?.episodeRecordings?.[0]);
    }
    return isSportSeriesRecording(recordingInfo?.eventRecordingItem);
  }, [recordingInfo, recordingType]);

  const isPartOfSportsOrTeamRecording = !isSingleEvent && (isTeamRecording || isSportRecording);

  const showTeamNote = useCallback(() => {
    if (isPartOfSportsOrTeamRecording) {
      if (primaryCTAActionType === RECORDING_PARAMS.DELETE) {
        return true;
      }
      if (recordingType === RECORDING_PARAMS.EVENT || recordingType === RECORDING_PARAMS.TEAM_EVENT) {
        return true;
      }
    }
    return false;
  }, [isPartOfSportsOrTeamRecording, primaryCTAActionType, recordingType]);

  useEffect(() => {
    if (recordingInfo) {
      let recordingInfoDetails;
      if (isMR) {
        if (recordingInfo.recordingSeriesCheck) {
          const getSpecificRecordingAsset =
            isProgramOfSeries && recordGUID
              ? recordingInfo.recordingSeriesCheck.recordings?.length > 0 &&
                recordingInfo.recordingSeriesCheck.recordings.find((recording) => recording.recordGUID === recordGUID)
              : recordingInfo.recordingSeriesCheck;
          recordingInfoDetails = {
            ...getSpecificRecordingAsset,
            isProgramOfSeries,
            recordingDefinitionId: recordingInfo.recordingSeriesCheck.recordingDefinitionId,
          };
        } else if (recordingInfo.recordingEventScheduledCheck) {
          recordingInfoDetails = recordingInfo.recordingEventScheduledCheck;
        } else {
          recordingInfoDetails = recordingInfo;
        }
        recordingInfoDetails.recordingInfo = recordingInfo;
        setRecordingInfoDetails(recordingInfoDetails);
      } else {
        if (recordingType === RECORDING_PARAMS.SERIES || recordingType === CONTENT_ITEM_TYPES.team) {
          if (recordingInfo.seriesRecordingItem?.metadata) {
            const recordingSeriesId = recordingInfo.seriesRecordingItem.metadata.recordingSeriesId;
            if (isRecordingRecorded && isPartOfSportsOrTeamRecording) {
              //when a series is deleted, if any of its programs are also recorded under different series, those matching programs must be deleted as well
              const recordings = getAllEventsOfSeries(recordingInfo?.eventRecordingsList, recordingSeriesId);
              recordingInfoDetails = { recordingsToDelete: recordings };
            } else {
              recordingInfoDetails = {
                recordId: recordingSeriesId,
                keepRecordedEpisodes: !isRecordingRecorded,
              };
            }
          }
        } else if (
          recordingType === RECORDING_PARAMS.TEAM_EVENT ||
          (isPartOfSportsOrTeamRecording && recordingType === RECORDING_PARAMS.EVENT)
        ) {
          // To delete event with same contentId in case of team/sport event
          const programId = recordingInfo?.eventRecordingItem?.metadata?.programId;
          const matchedRecordings = buildAndFindEventContentIdIndex(recordingInfo?.eventRecordingsList, programId);

          recordingInfoDetails = {
            recordingsToDelete: matchedRecordings,
          };
        } else {
          if (recordingInfo.eventRecordingItem?.metadata) {
            recordingInfoDetails = {
              recordingsToDelete: [
                {
                  recordId: recordingInfo.eventRecordingItem.metadata.contentId,
                  startDeltaTime: recordingInfo.eventRecordingItem.metadata.startDeltaTime,
                },
              ],
            };
          }
        }

        if (recordingInfoDetails) recordingInfoDetails.recordingInfo = recordingInfo;
        setRecordingInfoDetails(recordingInfoDetails);
      }
    }
  }, [
    recordingInfo,
    isMR,
    isProgramOfSeries,
    recordGUID,
    recordingType,
    isRecordingRecorded,
    isPartOfSportsOrTeamRecording,
  ]);

  useEffect(() => {
    let recordingMessage,
      headerText,
      primaryCTAKeyPrefix,
      cancelCTAText,
      keepCTAText,
      eventKeepCTAText,
      eventCancelCTAText,
      programMetadata,
      seasonNumber,
      episodeNumber,
      autoGeneratedObject,
      programName;

    if (programDetails && recordingType === RECORDING_PARAMS.EVENT) {
      programMetadata = programDetails.metadata || programDetails.recordings?.[0]?.metadata;
    } else if (recordingType === RECORDING_PARAMS.TEAM_EVENT) {
      programMetadata = recordingInfo?.eventRecordingItem?.metadata;
    }

    if (programMetadata) {
      seasonNumber = programMetadata.seasonNumber || programMetadata.season;
      episodeNumber = programMetadata.episodeNumber || programMetadata.episodeId;
      autoGeneratedObject = getAutoGeneratedObject(programMetadata);

      if (
        autoGeneratedObject &&
        (recordingType === RECORDING_PARAMS.EVENT || recordingType === RECORDING_PARAMS.TEAM_EVENT)
      ) {
        programName = getAutogeneratedEpisodeString(autoGeneratedObject, programMetadata);
      }
    }

    if (
      (!programDetails?.openRecordedEditPanel &&
        (!isRecordingRecorded || programDetails?.isRecordingRecorded === false)) ||
      (isRecordingNow && recordingType === RECORDING_PARAMS.EVENT)
    ) {
      if (recordingType === RECORDING_PARAMS.EVENT || recordingType === RECORDING_PARAMS.TEAM_EVENT) {
        recordingMessage = programName
          ? translate("stb_cancel_recording_program").replace("%s", programName)
          : translate("cancel_recording_single");
      } else if (recordingType === CONTENT_ITEM_TYPES.team) {
        recordingMessage = translate("cancel_team_recording_body").replace(
          "%s",
          recordingInfo?.seriesRecordingItem?.metadata?.title
        );
      } else {
        recordingMessage = translate(RECORDING_PARAMS.SERIES_CANCEL_MESSAGE).replace(
          "%s",
          recordingInfo?.seriesRecordingItem?.metadata?.title
        );
      }

      eventCancelCTAText = translate(RECORDING_PARAMS.CANCEL_RECORDING);
      eventKeepCTAText = translate(RECORDING_PARAMS.KEEP_RECORDING);

      headerText = translate(RECORDING_PARAMS.CANCEL_RECORDING);
      primaryCTAKeyPrefix = RECORDING_PARAMS.CANCEL;
      if (recordingType === RECORDING_PARAMS.SERIES) {
        cancelCTAText = translate(RECORDING_PARAMS.CANCEL_SERIES);
        keepCTAText = translate(RECORDING_PARAMS.KEEP_SERIES);
        headerText = translate("cancel_series_recording");
      } else if (recordingType === CONTENT_ITEM_TYPES.team) {
        headerText = translate("cancel_team_recording");
        cancelCTAText = translate("cancel_team");
        keepCTAText = translate("keep_team");
      } else {
        cancelCTAText = eventCancelCTAText;
        keepCTAText = eventKeepCTAText;
      }
    } else {
      recordingMessage = translate(RECORDING_PARAMS.RECORDING_DELETE_MESSAGE);
      headerText = translate(RECORDING_PARAMS.DELETE_RECORDING);
      primaryCTAKeyPrefix = RECORDING_PARAMS.DELETE;
      cancelCTAText = headerText;
      keepCTAText = translate(RECORDING_PARAMS.KEEP_RECORDING);

      if (recordingType === RECORDING_PARAMS.EVENT) {
        if (programName) {
          recordingMessage = translate("delete_recording_program").replace("<program_name>", programName);
        }
      } else if (recordingType === RECORDING_PARAMS.SERIES || recordingType === CONTENT_ITEM_TYPES.team) {
        const totalRecordings =
          recordingInfo?.recordedItems?.length || recordingInfo?.seriesRecordingItem?.episodeRecordings?.length;
        cancelCTAText = translate("delete_events").replace("%s", totalRecordings);

        if (recordingType === RECORDING_PARAMS.SERIES) {
          headerText = translate("delete_series_recordings");
          keepCTAText = translate(RECORDING_PARAMS.KEEP_EPISODES);
          recordingMessage = translate("delete_recording_all_series").replace(
            "%s",
            recordingInfo?.seriesRecordingItem?.metadata?.title
          );
          if (!isSportRecording) {
            // regular series
            cancelCTAText = translate("delete_recordings_bulk_button").replace("%s", totalRecordings);
          }
        } else if (recordingType === CONTENT_ITEM_TYPES.team) {
          headerText = translate("delete_team_recording");
          keepCTAText = translate("keep_events");
          recordingMessage = translate("delete_team_recording_body").replace(
            "%s",
            recordingInfo?.seriesRecordingItem?.metadata?.title
          );
        }
      }
    }

    setHeadingText(headerText);

    let recordingCancelMessage = recordingMessage;
    if (recordingType === RECORDING_PARAMS.EVENT && programDetails && !isSportsEvent(programDetails)) {
      if (programMetadata) {
        const isContentEpisodic =
          isItemTypeEpisode(programMetadata) || programMetadata.uaGroupType === PAGE_CONTENT_ITEM_TYPES.tvShow;
        if (isContentEpisodic && recordingType === RECORDING_PARAMS.EVENT) {
          // Base on the test result on CPVR episode detail page, we need to make sure the following cancelCTAText and keepCTAText update only happens on event cancel popup
          if (seasonNumber && episodeNumber) {
            const programName = getAutogeneratedEpisodeString(autoGeneratedObject, programMetadata);

            recordingCancelMessage = translate(
              (!programDetails?.openRecordedEditPanel || isRecordingNow) &&
                (!isRecordingRecorded || programDetails?.isRecordingRecorded === false)
                ? RECORDING_PARAMS.RECORDING_CANCEL_MESSAGE
                : "delete_recording_program"
            ).replace("<program_name>", programName);
          }

          cancelCTAText = translate(RECORDING_PARAMS.CANCEL_RECORDING);
          keepCTAText = translate(RECORDING_PARAMS.KEEP_RECORDING);
        }
      }
    }

    setMessageText(recordingCancelMessage);
    setCancelCTAText(cancelCTAText);
    setKeepCTAText(keepCTAText);
    setPrimaryCTAActionType(primaryCTAKeyPrefix);
  }, [
    isRecordingRecorded,
    programDetails,
    isProgramOfSeries,
    translate,
    recordingType,
    recordingInfo,
    recordingInfoDetails,
    isRecordingNow,
    isMR,
    isSportRecording,
  ]);

  const cancelRecording = () => {
    const isSeriesEvent = recordingType === RECORDING_PARAMS.SERIES;
    const isTeamRecordingAction = recordingType?.toLowerCase() === CONTENT_ITEM_TYPES.team;
    const teamRecordingMetadata = isTeamRecordingAction ? recordingInfo?.seriesRecordingItem?.metadata : null;
    // Sport name may be on the episode's sports metadata (schedule items), seriesTitle (recording items from API), or passed directly from the page
    const teamSport = isTeamRecordingAction
      ? recordingInfo?.assetToRecord?.metadata?.extendedMetadata?.seriesTitle ||
        teamRecordingMetadata?.seriesTitle ||
        recordingInfo?.seriesRecordingItem?.episodeRecordings?.[0]?.metadata?.seriesTitle ||
        recordingInfo?.seriesRecordingItem?.episodeRecordings?.[0]?.metadata?.extendedMetadata?.dlum?.sortTitle ||
        recordingInfo?.seriesRecordingItem?.episodeRecordings?.[0]?.metadata?.title ||
        recordingInfo?.seriesRecordingItem?.episodeRecordings?.[0]?.metadata?.extendedMetadata?.dlum?.sports?.name ||
        recordingInfo?.assetToRecord?.metadata?.extendedMetadata?.dlum?.sports?.name ||
        recordingInfo?.teamSport
      : null;
    // Stop = cancelling a scheduled or in-progress recording; Delete = removing an already-recorded item
    const analyticsEventType =
      isRecordingRecorded && !isRecordingNow
        ? ANALYTICS_EVENT_TYPES.VIDEO_RECORD_DELETE
        : ANALYTICS_EVENT_TYPES.VIDEO_RECORD_STOP;
    if (
      !isMR &&
      isCPVRRecordingInProgress(recordingInfo.eventRecordingItem) &&
      recordingType === RECORDING_PARAMS.EVENT
    ) {
      trackGenericAction(
        analyticsEventType,
        {
          isItemLive: true,
          isSeriesRecording: isSeriesEvent,
          isTeamRecording: isTeamRecordingAction,
          ...(isTeamRecordingAction ? { teamSport, teamName: teamRecordingMetadata?.title } : {}),
          isSeriesEvent,
          ...(isSeriesEvent
            ? mapRecordingSeriesMediaContent(recordingInfoDetails?.recordingInfo?.assetToRecord)
            : recordingInfoDetails?.recordingInfo?.assetToRecord),
          mappedContentType: MAPPED_CONTENT_TYPES.CPVR,
        },
        isDynatraceTrackingEnabled
      );
      if (isConvivaAppTrackerEnabled) {
        trackConvivaCustomEvent(
          ANALYTICS_EVENT_TYPES.VIDEO_RECORD_STOP,
          getCustomContextMetadata(recordingInfoDetails, userProfile, appProvider, isInHome)
        );
      }
      logDTEvent(DT_EVENTS.RECORDING_STOP, null, isDynatraceTrackingEnabled);
      stopCPVRRecording(appProvider, recordingInfo, editRecordingAction);
    } else {
      if (recordingInfoDetails) {
        trackGenericAction(
          analyticsEventType,
          {
            isItemLive: true,
            isSeriesRecording: isSeriesEvent,
            isTeamRecording: isTeamRecordingAction,
            ...(isTeamRecordingAction ? { teamSport, teamName: teamRecordingMetadata?.title } : {}),
            isSeriesEvent,
            ...(isSeriesEvent
              ? mapRecordingSeriesMediaContent(
                  isMR ? recordingInfoDetails?.recordingInfo : recordingInfoDetails?.recordingInfo?.seriesRecordingItem
                )
              : isMR
              ? mapRecordingSeriesMediaContent(recordingInfoDetails?.recordingInfo)
              : recordingInfoDetails?.recordingInfo.eventRecordingItem),
            mappedContentType: isMR ? MAPPED_CONTENT_TYPES.LPVR : MAPPED_CONTENT_TYPES.CPVR,
          },
          isDynatraceTrackingEnabled
        );
        if (isConvivaAppTrackerEnabled) {
          trackConvivaCustomEvent(
            analyticsEventType,
            getCustomContextMetadata(recordingInfoDetails, userProfile, appProvider, isInHome)
          );
        }
        // We need to send "cancel" in action as payload in deleteRecording() method when we try to cancel an ongoing recording(event/episode part of series/series).
        deleteRecording(
          appProvider,
          isMR,
          recordingInfoDetails,
          recordingType,
          deleteRecordingAction,
          !isRecordingRecorded || (isRecordingNow && isProgramOfSeries)
        );
      }
    }
    closeRecordingSettings();
    closeModal();
  };

  return (
    <React.Fragment>
      <div className="cancel-modal-backdrop"></div>
      <div className="cancel-modal-container">
        <div className="cancel-modal-popup-container">
          <PopUpOutline className="cancel-modal-popup">
            <div className="cancel-type">{headingText}</div>
            <div className="cancel-item">
              <div className="cancel-item-details">
                <div
                  className={
                    recordingType === CONTENT_ITEM_TYPES.team ? "cancel-team-recording-subtitle" : "cancel-subtitle"
                  }
                >
                  <p>{messageText}</p>
                </div>
                {showTeamNote() && (
                  <div className="team-recording-note">
                    <p>{translate("cancel_recording_team_warning")}</p>
                  </div>
                )}
                <button
                  className="cancel-item-title"
                  onClick={(event) => {
                    event.stopPropagation();
                    cancelRecording();
                  }}
                >
                  <p>{cancelCTAText}</p>
                </button>
                <button className="cancel-item-title shaded" onClick={() => closeModal()}>
                  <p>{keepCTAText}</p>
                </button>
              </div>
            </div>
          </PopUpOutline>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  editRecordingAction,
  deleteRecordingAction,
};

CancelPopup.propTypes = {
  recordingInfo: PropTypes.object.isRequired,
  programDetails: PropTypes.object,
  isMR: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isRecordingRecorded: PropTypes.bool,
  recordingType: PropTypes.string.isRequired,
  closeRecordingSettings: PropTypes.func,
  isProgramOfSeries: PropTypes.bool,
  recordGUID: PropTypes.string,
};

CancelPopup.defaultProps = {
  programDetails: null,
  isRecordingRecorded: false,
  closeRecordingSettings: () => null,
  isProgramOfSeries: false,
  recordGUID: "",
};

export default connect(null, mapDispatchToProps)(CancelPopup);
